import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { plantsForAnalysisQueryOptions } from './plants-for-analysis.query-options';

/**
 * 발전 분석용 발전소 목록 query — `plantsForAnalysisQueryOptions`(entity SSOT)를 컨텍스트에 적용. app-legacy(v3).
 * 발전량/수익 화면 스코프·좌표·인버터 용량 소스.
 */
export function usePlantsForAnalysisQuery() {
  const api = useApiAppLegacy();
  return useQuery(plantsForAnalysisQueryOptions(api));
}
